import { Result } from '@/generic/functional';

export class DateTime {
  readonly #date: Date;

  private constructor(date: Date) {
    this.#date = date;
  }

  static fromISO(iso: string): Result<Error, DateTime> {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
      return Result.error(new Error(`Invalid ISO date: ${iso}`));
    }
    return Result.success(new DateTime(date));
  }

  get human(): string {
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(this.#date);
  }
}
